import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { continueApplicationProcessing } from './application';
import {
  QualificationAction,
  CollectBusinessApplicantInfoPage,
  QualificationStepResponse,
} from '../../../domain/qualification';
import { RootState } from '../../../store';
import { DataLoadState, ErrorType, initialDataLoadState } from '../../../store/reducers/common';

export type RegistrationState = DataLoadState & {
  initialized: boolean;
  action?: QualificationAction;
};
const initialState: RegistrationState = {
  ...initialDataLoadState,
  initialized: false,
};

export type NextStepPayload =
  | {
      action: 'collect_business_and_applicant_info';
      resuming?: boolean;
      page: CollectBusinessApplicantInfoPage;
      gotoNextPage: boolean;
    }
  | {
      action?: Exclude<QualificationAction, 'collect_business_and_applicant_info'>;
      resuming?: boolean;
      page?: never;
      gotoNextPage: boolean;
    };

const slice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nextStep: (state, _action: PayloadAction<NextStepPayload>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    nextStepSuccess: (state, { payload: { action } }: PayloadAction<QualificationStepResponse>) => ({
      ...state,
      loading: false,
      action,
    }),
    nextStepFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
      initialized: true,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(continueApplicationProcessing, (state) => ({
      ...state,
      initialized: true,
    }));
  },
});

export const { nextStep, nextStepFail, nextStepSuccess } = slice.actions;

export default slice.reducer;

export const selectnextStep = (state: RootState) => state.nextStep;
